package com.exura

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseApp
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.functions.functions
import dev.gitlive.firebase.initialize

object FirebaseConfig {

        private const val FIREBASE_API_KEY = "AIzaSyB3NMAZLvu9W6wbJBSzkqSGLkBRYw-VWKg"
        private const val FIREBASE_AUTH_DOMAIN = "exura-be.firebaseapp.com"
        private const val FIREBASE_PROJECT_ID = "exura-be"
        private const val FIREBASE_STORAGE_BUCKET = "exura-be.firebasestorage.app"
        private const val FIREBASE_MESSAGING_SENDER_ID = "966364990558"
        private const val FIREBASE_APP_ID = "1:966364990558:web:6ed8c648491b6b103878cf"

        private const val isDev = false

        private val config = if (isDev) {
                FirebaseOptions(
                        applicationId = "x",
                        apiKey = "XXXXXX-XXXX",
                        projectId = "exura-be",
                        storageBucket = "exura-be.firebasestorage.app",
                        authDomain = "exura-be.firebaseapp.com",
                        gcmSenderId = "966364990558",
                )
        } else {
                FirebaseOptions(
                        applicationId = FIREBASE_APP_ID,
                        apiKey = FIREBASE_API_KEY,
                        projectId = FIREBASE_PROJECT_ID,
                        storageBucket = FIREBASE_STORAGE_BUCKET,
                        authDomain = FIREBASE_AUTH_DOMAIN,
                        gcmSenderId = FIREBASE_MESSAGING_SENDER_ID,
                )
        }

        fun initialize(): FirebaseApp {
                // Initialize Firebase
                console.log("Initializing Firebase with config: [REDACTED]")
                val app = Firebase.initialize(options = config)
                console.log("Firebase initialized successfully")

                if (isDev) {
                        Firebase.auth.useEmulator("localhost", 9099)
                        Firebase.functions.useEmulator("localhost", 5001)
                }
                return app
        }
}
